<app-blade-right>
  <h1>{{data?.id}}</h1>
  <h2 (click)="remove.emit('heyyyyyyy')">close</h2>

</app-blade-right>
